SectionProfile.Event.Results = Class(
	/**
	 * @lends {SectionProfile.Event.Results#}
	 */
	{
		__NAME: 'SectionProfile.Event.Results',

		name: 'results',

		_draw: function(){
			this._mGetTeam = new DR.results.GetTeam();
			this.apiCall.addMethod(this._mGetTeam);
		},

		_ready: function() {
			if( !this.event.showResults ){
				Section.navigate(D.url('/profile/event/' + this.event.seoTitle));
				return;
			}
			this._drawSidebar();
			this._drawTabs();

			if( this._mGetTeam.error ){
				Section.navigate(D.url('/profile/event/' + this.event.seoTitle));
				return;
			}

			const re = this._mGetTeam.re;

			mkE({
				tag: 'div',
				className: 'profile-results',
				els: [
					{
						tag: 'div',
						className: 'results-image'
					},
					{
						tag: 'h2',
						text: D.Lang.get('profile.results.title.' + (this.event.maxPlayers > 1 ? 'team' : 'single'))
					},
					{
						tag: 'p',
						text: D.Lang.get('profile.results.text.' + (this.event.maxPlayers > 1 ? 'team' : 'single')).replace('%PLACE%', re.team.place)
					},
					{
						tag: 'p',
						text: D.Lang.get('profile.results.subText')
					},
					{
						tag: 'div',
						className: 'total-points',
						text: re.team.points + ' ' + D.Lang.nget(re.team.points, 'profile.results.points')
					},
					this._tasks = mkE({
						tag: 'div',
						className: 'results-tasks'
					})
				]
			}).append(this._content);

			re.tasks.forEach(task => {
				mkE({
					tag: 'div',
					className: 'results-task results-task-' + task.type,
					els: [
						{
							tag: 'div',
							className: 'caption',
							text: D.Lang.get('profile.results.tasks.' + task.type)
						},
						{
							tag: 'div',
							className: 'points',
							text: task.points
						}
					]
				}).append(this._tasks);
			})
		}
	},
	SectionProfile.EventBase
);
